import React from 'react';
import PropTypes from 'prop-types';
import {getDataAttribute} from 'epic-common/src/browser';
import IconQR from './IconQR';

class Social extends React.PureComponent {
    static propTypes = {
        socialLinks: PropTypes.array
    };

    onClick = (e) => {
        if (e.button && e.button > 0) return;
        const index = +getDataAttribute(e.currentTarget, 'index');
        if (index) {
            const link = this.props.socialLinks[index];
            if (link && link.qrCode) {
                e.preventDefault();
            }
        }
    };

    render() {
        const socialLinks = this.props.socialLinks || [];

        return (
            <div className="col-xs-10 col-sm-8">
                <ul className="social">
                    {
                        socialLinks.map((link, i) => {
                            return (
                                <li key={`social-${link.id}`}>
                                    <a
                                        id={link.id}
                                        href={link.href}
                                        onClick={this.onClick}
                                        data-index={i}
                                        target="_blank"
                                        rel="noopener noreferrer">
                                        <IconQR id={link.id} qrCode={link.qrCode} />
                                    </a>
                                </li>
                            );
                        })
                    }
                </ul>
            </div>
        );
    }
}

export default Social;
